// extracted by mini-css-extract-plugin
export default {"container":"dcc_cartboxRemarks-container","blockEntry":"dcc_cartboxRemarks-blockEntry","entryKey":"dcc_cartboxRemarks-entryKey","entryValue":"dcc_cartboxRemarks-entryValue"};